import {AdminHomeView} from "./AdminHomeView";
import {Item, Rental, User} from "../types";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {ItemView} from "./ItemView";
import {Box} from "@variocube/app-api";
import {BoxView} from "./BoxView";
import {ItemRemoval} from "./types";
import {RemovalFlow} from "./RemovalFlow";
import {StoreBoxFlow} from "./StoreBoxFlow";
import {StoreItemFlow} from "./StoreItemFlow";
import {InspectorView} from "./InspectorView";
import {InspectItemView} from "./InspectItemView";

export interface AdminViewProps {
    user?: User;
    rentals: Rental[];
    items: Item[];
    itemsForInspection?: Item[];
    selectedItem?: Item;
    onDone: () => void;
}

export function AdminView({user, rentals, items, itemsForInspection, selectedItem, onDone}: AdminViewProps) {
    const [item, setItem] = useState<Item>();
    const [inspection, setInspection] = useState<Item>();
    const [box, setBox] = useState<Box>();
    const [removal, setRemoval] = useState<ItemRemoval>();
    const [storeBox, setStoreBox] = useState<Box>();
    const [storeItem, setStoreItem] = useState<Item>();

    const reset = useCallback(() => {
        setItem(undefined);
        setBox(undefined);
        setRemoval(undefined);
        setStoreBox(undefined);
        setStoreItem(undefined);
    }, []);

    useEffect(() => {
        if(selectedItem) {
            setItem(selectedItem);
        }else {
            reset();
        }
    }, [selectedItem]);

    const handleRemovalDone = useCallback(() => setRemoval(undefined), []);
    const handleStoreBoxDone = useCallback(() => setStoreBox(undefined), []);
    const handleStoreItemDone = useCallback(() => setStoreItem(undefined), []);

    const handleBack = useCallback(() => {
        if(selectedItem) {
            onDone();
        }else {
            reset();
        }
    }, [selectedItem, onDone, reset]);

    if (removal) {
        return <RemovalFlow removal={removal} onDone={handleRemovalDone}/>
    }
    if (storeBox) {
        return <StoreBoxFlow box={storeBox} onDone={handleStoreBoxDone} />
    }
    if (storeItem) {
        return <StoreItemFlow item={storeItem} onDone={handleStoreItemDone} />
    }
    if (user && inspection) {
        return <InspectItemView user={user} item={inspection} onClose={() => setInspection(undefined)} />
    }
    if (item) {
        return (
            <ItemView user={user} item={item} onBack={handleBack} onStoreItem={setStoreItem} onRemoveItem={setRemoval}/>
        );
    }
    if (box) {
        return (
            <BoxView user={user} box={box} items={items} rentals={rentals} onBack={reset} onStoreBox={setStoreBox} onRemoveItem={setRemoval}/>
        )
    }
    return (
        <AdminHomeView
            rentals={rentals}
            items={items}
            onOpenItem={setItem}
            onOpenBox={setBox}
            itemsForInspection={itemsForInspection}
            onInspectItem={setInspection}
            onDone={onDone}
        />
    );
}